import _classCallCheck from "/opt/build/repo/front-end/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/front-end/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
function wireUpEventHandler(handlerName, apiConnector, handlerParam) {
  if (handlerParam) {
    // Passes a 'next' parameter which allows a handler to work as
    // middleware for a connector
    if (apiConnector) {
      var next = apiConnector[handlerName].bind(apiConnector);
      return function () {
        for (var _len = arguments.length, params = new Array(_len), _key = 0; _key < _len; _key++) {
          params[_key] = arguments[_key];
        }
        return handlerParam.apply(void 0, params.concat([next]));
      };
    }
    return handlerParam;
  }
  if (apiConnector && apiConnector[handlerName]) return apiConnector[handlerName].bind(apiConnector);
  return function () {
    throw "No ".concat(handlerName, " handler provided and no Connector provided. You must configure one or the other.");
  };
}
var Events = /*#__PURE__*/function () {
  function Events() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      apiConnector = _ref.apiConnector,
      onSearch = _ref.onSearch,
      onAutocomplete = _ref.onAutocomplete,
      onResultClick = _ref.onResultClick,
      onAutocompleteResultClick = _ref.onAutocompleteResultClick,
      _ref$plugins = _ref.plugins,
      plugins = _ref$plugins === void 0 ? [] : _ref$plugins;
    _classCallCheck(this, Events);
    this.search = wireUpEventHandler("onSearch", apiConnector, onSearch);
    this.autocomplete = wireUpEventHandler("onAutocomplete", apiConnector, onAutocomplete);
    this.resultClick = wireUpEventHandler("onResultClick", apiConnector, onResultClick);
    this.autocompleteResultClick = wireUpEventHandler("onAutocompleteResultClick", apiConnector, onAutocompleteResultClick);
    this.plugins = plugins;
  }
  _createClass(Events, [{
    key: "emit",
    value: function emit(event) {
      this.plugins.forEach(function (middleware) {
        middleware.subscribe(event);
      });
    }
  }]);
  return Events;
}();
export default Events;